/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const upsertPicklistOptionRequestSchema = z.object({
  archived: z.boolean(),
  color: z.string(),
  id: z.int().nullish(),
  name: z.string(),
});
